import { Injectable, inject } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { MyPlanData } from '../core/models/subscription.model';
import { SubscriptionService } from './api/subscription.service';

@Injectable({ providedIn: 'root' })
export class PlanExpiredService {
  private _subscriptionService = inject(SubscriptionService);
  private _expired$  = new BehaviorSubject<boolean>(false);
  private _planData$ = new BehaviorSubject<MyPlanData | null>(null);

  readonly isExpired$ = this._expired$.asObservable();
  readonly planData$  = this._planData$.asObservable();

  setPlanData(data: MyPlanData | null): void {
    this._planData$.next(data);
    const isExpired = data?.subscription?.is_expired ?? false;
    this._expired$.next(isExpired);
  }

  /** Valor sincrónico actual */
  isExpiredValue(): boolean { return this._expired$.value; }

  /** Datos sincrónicos del plan — usar para validar límites */
  planDataValue(): MyPlanData | null { return this._planData$.value; }

  /** Refresca los datos del plan desde el servidor */
  refresh(): void {
    this._subscriptionService.getMySubscription().subscribe({
      next:  (res) => this.setPlanData(res?.data ?? null),
      error: ()    => {},
    });
  }

  show(): void { this._expired$.next(true); }
  hide(): void { this._expired$.next(false); }
}
